module.exports = __webpack_public_path__ + "static/expert-political-judgment-f510e0a65da38b6b09ecf06b6b99c43e.jpg";